import { ArtistAttachment as GQLItem } from '../../generated/graphql';
import * as Attachment from '../Attachment/Attachment';
import { z } from 'zod';

export const artistAttachmentSchema = z.object({
  attachment: Attachment.attachmentSchema,
});

export type ArtistAttachment = z.infer<typeof artistAttachmentSchema>;

export const fromGql = (item: GQLItem): ArtistAttachment => ({
  attachment: Attachment.fromGql(item.attachment),
});

export const fromGqlCollection = (items: GQLItem[]): ArtistAttachment[] =>
  items.map(fromGql);
